<template>
  <div>
    <v-expansion-panels accordion multiple>
      <v-expansion-panel>
        <v-expansion-panel-header> ช่อง input </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="px-0"> ชื่อหัวข้อ </v-card-text>
            <v-card-text class="pa-0">
              <v-text-field
                v-model="welcome_theme.default.field_label"
                outlined
                dense
                maxlength="28"
                counter="28"
              ></v-text-field>
            </v-card-text>
            <v-card-text class="pa-0">
              <v-radio-group
                v-model="welcome_theme.default.field_type"
                hide-details=""
              >
                <template v-slot:label> รูปแบบช่อง input </template>
                <v-radio value="outlined">
                  <template v-slot:label>
                    <div>แบบที่ 1</div>
                  </template>
                </v-radio>
                <v-radio value="solo">
                  <template v-slot:label>
                    <div>แบบที่ 2</div>
                  </template>
                </v-radio>
                <v-radio value="filled">
                  <template v-slot:label>
                    <div>แบบที่ 3</div>
                  </template>
                </v-radio>
                <v-radio value="normal">
                  <template v-slot:label>
                    <div>แบบที่ 4</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card-text>
            <v-card-text class="px-0"> สีพื้นหลังช่อง input </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="welcome_theme.default.field_bg"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text
              v-if="welcome_theme.default.field_type !== 'solo'"
              class="pa-0"
            >
              สีช่อง input ขณะพิมพ์
            </v-card-text>
            <v-card-text
              v-if="welcome_theme.default.field_type !== 'solo'"
              class="pa-0"
            >
              <v-color-picker
                v-model="welcome_theme.default.field_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          ปุ่มเริ่มแบบสอบถาม
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="px-0"> ข้อความ </v-card-text>
            <v-card-text class="pa-0">
              <v-text-field
                v-model="welcome_theme.default.button.text"
                outlined
                dense
                maxlength="30"
                counter="30"
              ></v-text-field>
            </v-card-text>
            <v-card-text class="pa-0">
              <v-radio-group
                v-model="welcome_theme.default.button.bt_texttype"
                hide-details=""
                @change="StartButtonUI"
              >
                <template v-slot:label> รูปแบบปุ่ม </template>
                <v-radio value="button">
                  <template v-slot:label>
                    <div>แบบที่ 1</div>
                  </template>
                </v-radio>
                <v-radio value="text">
                  <template v-slot:label>
                    <div>แบบที่ 2</div>
                  </template>
                </v-radio>
                <v-radio value="outlined">
                  <template v-slot:label>
                    <div>แบบที่ 3</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card-text>
            <v-card-text class="pa-0">
              <v-checkbox
                v-model="welcome_theme.default.button.bt_block"
                label="ปุ่มยาวเต็มกรอบ"
                hide-details=""
              ></v-checkbox>
            </v-card-text>
            <v-card-text class="px-0">
              <v-checkbox
                v-model="welcome_theme.default.button.bt_rounded"
                label="ขอบมน"
                hide-details=""
              ></v-checkbox>
            </v-card-text>
            <v-card-text
              v-show="welcome_theme.default.button.bt_texttype === 'button'"
              class="pa-0"
            >
              สีพื้นหลังข้อความ
            </v-card-text>
            <v-card-text
              v-show="welcome_theme.default.button.bt_texttype === 'button'"
              class="pa-0"
            >
              <v-color-picker
                v-model="welcome_theme.default.button.bg_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0"> สีข้อความ / สีเส้นขอบของปุ่ม </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="welcome_theme.default.button.text_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: ["welcome_theme"],
  methods: {
    StartButtonUI() {
      let bg_color = this.welcome_theme.wc_color;
      let button_bg_color = this.welcome_theme.default.button.bg_color;
      let button_text_color = this.welcome_theme.default.button.text_color;
      if (
        this.welcome_theme.default.button.bt_texttype === "text" ||
        this.welcome_theme.default.button.bt_texttype === "outlined"
      ) {
        if (
          bg_color === button_text_color &&
          button_bg_color !== button_text_color
        ) {
          this.welcome_theme.default.button.text_color = button_bg_color;
        }
      } else {
        if (this.welcome_theme.default.button.text_color === button_bg_color) {
          this.welcome_theme.default.button.text_color = bg_color;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
